import { createRoutine } from 'redux-saga-routines';
import {
  GET_PRODUCTS,
  GET_USER_SUBSCRIPTIONS,
  GET_USER_CARDS,
  CANCEL_SUBSCRIPTION,
  ADD_SUBSCRIPTION,
  GET_SUBSCRIPTIONS,
} from './constants';

export const getProductsAction = createRoutine(GET_PRODUCTS);
export const getBankCardsAction = createRoutine(GET_USER_CARDS);
export const getUserSubscriptionsAction = createRoutine(GET_USER_SUBSCRIPTIONS);
export const getSubscriptionsAction = createRoutine(GET_SUBSCRIPTIONS);
export const cancelSubscriptionAction = createRoutine(CANCEL_SUBSCRIPTION);
export const addSubscriptionAction = createRoutine(ADD_SUBSCRIPTION);
